import { render } from "./SourceDot.vue?vue&type=template&id=72677ac4&scoped=true"
import script from "./SourceDot.vue?vue&type=script&lang=js"
export * from "./SourceDot.vue?vue&type=script&lang=js"

import "./SourceDot.vue?vue&type=style&index=0&id=72677ac4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72677ac4"]])

export default __exports__